import { render, staticRenderFns } from "./MobileLandingPage.vue?vue&type=template&id=fd9c603e&"
import script from "./MobileLandingPage.vue?vue&type=script&lang=js&"
export * from "./MobileLandingPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports